<div class="ir-plugin th-plugin" *ngIf="plugin">
  <div class="ir-line ir-plugin-title" [ngClass]="{ 'ir-plugin-gray': showBreadcrumbs }">
    <div class="ir-line--right">
      <div
        class="ir-btn"
        *ngIf="showHelpButton"
        [ngClass]="showPluginHelp ? 'th-btn-action' : 'th-btn-normal'"
        (click)="showHidePluginHelp()"
      >
        <span>?</span>
      </div>
      <div
        class="ir-btn"
        [ngClass]="showValidations ? 'th-btn-action' : 'th-btn-normal'"
        [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
        [routerLink]="getEditRoute()"
      >
        <span>{{ (showValidations ? 'common.open' : 'common.edit') | translate }}</span>
      </div>
    </div>
    <div class="ir-line-content">
      <span>
        {{ showBreadcrumbs ? plugin.inspection.name + ' / ' : '' }}
        {{ showBreadcrumbs && plugin.point?.name ? plugin.point?.name + ' / ' : '' }}
        {{ 'plugins.jobanalysis.name' | translate }}</span
      >
      <!--<strong>- AX87</strong>-->
    </div>
  </div>
  <div class="ir-line ir-plugin-validation" *ngIf="showValidations">
    <table class="ir-plugin-table">
      <tr class="th-plugin-line--content ir-plugin-gray">
        <td class="th-plugin-line--data" >
          <div *ngFor="let message of messages"><span  innerHtml="{{ message | translate: { value: plugin } }}"></span>
      </div>  </td>
      </tr>
    </table>
  </div>
  <div class="ir-plugin-content" *ngIf="showContent">
    <p class="ir-plugin-instruction" *ngIf="showPluginHelp">
      <span innerHtml="{{ plugin?.description }}"></span>
    </p>
    <div *ngFor="let job of jobAnalysisItems; last as last">
      <table class="ir-plugin-table">
        <tr>
          <td style="width: 40%">
            <span>{{ 'plugins.jobanalysis.jobdata.name' | translate }}</span>
          </td>
          <td class="th-plugin-values">
            <p>
              <span>{{ job.JobData.Name }}</span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <span>{{ 'plugins.jobanalysis.jobdata.machine' | translate }}</span>
          </td>
          <td class="th-plugin-values">
            <p>
              <span>{{ job.JobData.Machine }}</span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <span>{{ 'plugins.jobanalysis.jobdata.machine' | translate }} #</span>
          </td>
          <td class="th-plugin-values">
            <p>
              <span>{{ job.JobData.Serial }}</span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <span>{{ 'plugins.jobanalysis.jobdata.material' | translate }}</span>
          </td>
          <td class="th-plugin-values">
            <p>
              <span>{{ job.JobData.Material }}</span>
            </p>
          </td>
        </tr>
      </table>
      <table class="ir-plugin-table" [style.margin-bottom.px]="!last ? '40' : ''">
        <tr class="th-plugin-line--subheader bottom-border">
          <td></td>
          <td class="th-plugin-values">
            <span
              ><strong>{{ 'plugins.jobanalysis.setup.setup-time' | translate }}</strong> ({{
                'plugins.jobanalysis.setup.min' | translate
              }})</span
            >
          </td>
          <td class="th-plugin-values">
            <span
              ><strong>{{ 'plugins.jobanalysis.output.net-output' | translate }}</strong> ({{
                'plugins.jobanalysis.output.units-hour' | translate
              }})</span
            >
          </td>
        </tr>
        <tr>
          <td style="width: 40%">
            <span>{{ 'plugins.jobanalysis.performance.current' | translate }}</span>
          </td>
          <td class="th-plugin-values">
            <p>
              <span>{{ job.Setup.CurrentPerformance }}</span>
            </p>
          </td>
          <td class="th-plugin-values">
            <p>
              <span>{{ job.Output.CurrentPerformance }}</span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <span>{{ 'plugins.jobanalysis.performance.estimated' | translate }}</span>
          </td>
          <td class="th-plugin-values">
            <p>
              <span>{{ job.Setup.EstimatedPerformance }}</span>
            </p>
          </td>
          <td class="th-plugin-values">
            <p>
              <span>{{ job.Output.EstimatedPerformance }}</span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <span>{{ 'plugins.jobanalysis.performance.measured' | translate }}</span>
          </td>
          <td class="th-plugin-values">
            <p>
              <span>{{ job.Setup.MeasuredPerformance }}</span>
            </p>
          </td>
          <td class="th-plugin-values">
            <p>
              <span>{{ job.Output.MeasuredPerformance }}</span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <span>{{ 'plugins.jobanalysis.performance.acceptance-rate' | translate }} (%)</span>
          </td>
          <td colspan="2" class="th-plugin-values">
            <p>
              <span>{{ job.AcceptanceRate }}</span>
            </p>
          </td>
        </tr>
        <tr *ngIf="job.Comment">
          <td>
            <span>{{ 'plugins.jobanalysis.performance.comment' | translate }}</span>
          </td>
          <td colspan="2" class="th-plugin-values">
            <p>
              <span [innerHtml]="job.Comment"></span>
            </p>
          </td>
        </tr>
      </table>
    </div>
    <div></div>
  </div>
</div>
